export var GLOBAL = {
  //url: "http://localhost/proyecto-dsa-backend/public/api/"
  //url: 'http://localhost/declaraciones/declaraciones-back/public/api/'
  //url: "https://ismx.com.mx/declaraciones/api/"
  url: 'http://opergob.dyndns.org:8050/dsa/backend/public/api/'
};
